import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Dialog, IconButton, Tabs, Tab, Paper, List, ListItem, ListItemText, CircularProgress, Alert, Table, TableHead, TableBody, TableRow, TableCell, DialogTitle, DialogContent, DialogActions, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
// ✅ إضافة استيراد الأيقونات المفقودة
import CheckIcon from "@mui/icons-material/Check";
import PrintIcon from "@mui/icons-material/Print";
import TaghezScreen from "./TaghezScreen";
import { getAllKitchenUsers, addUserToKitchen, removeUserFromKitchen } from "../../../../services/Settings/kitchen/kitchenApi";
import { fetchKitchens } from "../../../../services/dashboard/apiServiceDashboard";
import { editPreparationTimeAlert, fetchSettings } from "../../../../services/Settings/InvoiceAndTaghezPrintingApi";

const TaghezSetup = () => {
  const [openModal, setOpenModal] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  
  // حالة المستخدمين
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [usersError, setUsersError] = useState("");

  // مودال ربط الأجهزة بالمطبخ
  const [openLinkModal, setOpenLinkModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedKitchenId, setSelectedKitchenId] = useState("");
  const [linkLoading, setLinkLoading] = useState(false);
  const [linkMsg, setLinkMsg] = useState("");

  // مودال إزالة الربط
  const [openUnlinkModal, setOpenUnlinkModal] = useState(false);
  const [unlinkUserId, setUnlinkUserId] = useState("");
  const [unlinkKitchenId, setUnlinkKitchenId] = useState("");
  const [unlinkKitchens, setUnlinkKitchens] = useState([]);
  const [unlinkLoading, setUnlinkLoading] = useState(false);
  const [unlinkMsg, setUnlinkMsg] = useState("");
  const [kitchens, setKitchens] = useState([]);

  // حالات التنبيه الصوتي
  const [prepSoundEnabled, setPrepSoundEnabled] = useState(false);
  const [prepSoundLoading, setPrepSoundLoading] = useState(false);
  const [prepSoundMsg, setPrepSoundMsg] = useState("");

  // ✅ useEffect لجلب حالة صوت التنبيه من الإعدادات عند تحميل المكون
  useEffect(() => {
    const loadPrepSoundSetting = async () => {
      try {
        const res = await fetchSettings();
        // دعم صيغ الاستجابة المختلفة
        const settings = res?.data?.settings?.[0] || res?.settings?.[0] || res?.data || {};
        const soundEnabled = Number(settings.preparation_time_alert) === 1;
        setPrepSoundEnabled(soundEnabled);
      } catch (err) {
        console.warn("Failed to fetch preparation_time_alert setting:", err);
      }
    };
    loadPrepSoundSetting();
  }, []);

  // جلب المستخدمين
  useEffect(() => {
    if (tabIndex === 0) {
      setUsersLoading(true);
      setUsersError("");
      getAllKitchenUsers()
        .then(setUsers)
        .catch((err) => setUsersError(err.message || "فشل في جلب المستخدمين"))
        .finally(() => setUsersLoading(false));
      // جلب المطابخ عند فتح التاب الأول
      fetchKitchens()
        .then((data) => {
          // إذا كانت الدالة ترجع مصفوفة مباشرة
          if (Array.isArray(data)) {
            setKitchens(data);
          } else if (data && Array.isArray(data.data)) {
            setKitchens(data.data);
          } else if (data && data.data && Array.isArray(data.data.data)) {
            setKitchens(data.data.data);
          } else {
            setKitchens([]);
          }
        })
        .catch(() => setKitchens([]));
    }
  }, [tabIndex]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  // حفظ الربط
  const handleLinkUserToKitchen = async () => {
    if (!selectedUserId || !selectedKitchenId) {
      setLinkMsg("❌ يرجى اختيار المستخدم والمطبخ.");
      return;
    }
    setLinkLoading(true);
    setLinkMsg("");
    try {
      await addUserToKitchen({ user_id: selectedUserId, kitchen_id: selectedKitchenId });
      setLinkMsg("✅ تم ربط المستخدم بالمطبخ بنجاح.");
      setSelectedUserId("");
      setSelectedKitchenId("");
      // إعادة تحميل المستخدمين بعد الربط
      getAllKitchenUsers().then(setUsers);
    } catch (err) {
      setLinkMsg(err.message || "❌ فشل في ربط المستخدم بالمطبخ.");
    } finally {
      setLinkLoading(false);
    }
  };

  // استخراج كل المطابخ من المستخدمين (بدون تكرار)
  const allKitchens = Array.from(
    users.reduce((acc, user) => {
      (user.kitchens || []).forEach((k) => acc.set(k.id, k));
      return acc;
    }, new Map()).values()
  );

  // فتح مودال إزالة الربط
  const handleOpenUnlinkModal = (user) => {
    setUnlinkUserId(user.id);
    setUnlinkKitchens(user.kitchens || []);
    setUnlinkKitchenId(""); // Reset selection
    setUnlinkMsg("");
    setOpenUnlinkModal(true);
  };

  // تنفيذ إزالة الربط
  const handleRemoveUserFromKitchen = async () => {
    if (!unlinkUserId || !unlinkKitchenId) {
      setUnlinkMsg("❌ يرجى اختيار المطبخ.");
      return;
    }
    setUnlinkLoading(true);
    setUnlinkMsg("");
    try {
      await removeUserFromKitchen({ user_id: unlinkUserId, kitchen_id: unlinkKitchenId });
      setUnlinkMsg("✅ تم إزالة الربط بنجاح.");
      setUnlinkUserId("");
      setUnlinkKitchenId("");
      setOpenUnlinkModal(false);
      // إعادة تحميل المستخدمين بعد الإلغاء
      getAllKitchenUsers().then(setUsers);
    } catch (err) {
      setUnlinkMsg(err.message || "❌ فشل في إزالة الربط.");
    } finally {
      setUnlinkLoading(false);
    }
  };

  // دالة تبديل حالة صوت التنبيه (تدعو editPreparationTimeAlert مع 1 أو 0)
  const handleTogglePrepSound = async () => {
    const newVal = prepSoundEnabled ? 0 : 1;
    setPrepSoundLoading(true);
    setPrepSoundMsg("");
    try {
      await editPreparationTimeAlert(newVal);
      setPrepSoundEnabled(!prepSoundEnabled);
      setPrepSoundMsg(newVal === 1 ? "✅ تم تفعيل التنبيه الصوتي" : "✅ تم تعطيل التنبيه الصوتي");
      setTimeout(() => setPrepSoundMsg(""), 2500);
    } catch (err) {
      setPrepSoundMsg(err?.message || "❌ فشل في تحديث حالة التنبيه");
      setTimeout(() => setPrepSoundMsg(""), 3000);
    } finally {
      setPrepSoundLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* زر/مؤشر التفعيل الصوتي أعلى الصفحة */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, gap: 1, alignItems: "center" }}>
        <Button
          variant={prepSoundEnabled ? "contained" : "outlined"}
          color="primary"
          onClick={handleTogglePrepSound}
          disabled={prepSoundLoading}
          startIcon={prepSoundEnabled ? <CheckIcon /> : <PrintIcon />}
        >
          {prepSoundEnabled ? "إيقاف صوت التنبيه" : "تفعيل صوت التنبيه"}
        </Button>
        {prepSoundLoading && <CircularProgress size={20} />}
        {prepSoundMsg && <Typography variant="body2" sx={{ color: prepSoundMsg.startsWith("✅") ? "success.main" : "error.main", ml: 1 }}>{prepSoundMsg}</Typography>}
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="تهيئة شاشة التجهيز" />
          <Tab label="تفعيل شاشة التجهيز" />
        </Tabs>
      </Paper>

      {tabIndex === 0 && (
        <Box>
          <Button
            variant="contained"
            color="secondary"
            sx={{ mb: 2 }}
            onClick={() => setOpenLinkModal(true)}
          >
            ربط أجهزة بالمطابخ
          </Button>
          {/* عرض المستخدمين */}
          {usersLoading ? (
            <CircularProgress sx={{ mt: 2 }} />
          ) : usersError ? (
            <Alert severity="error" sx={{ mt: 2 }}>{usersError}</Alert>
          ) : (
            <Paper sx={{ mt: 2, p: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                مستخدمو المطابخ:
              </Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>المعرف</TableCell>
                    <TableCell>الاسم</TableCell>
                    <TableCell>اسم المستخدم</TableCell>
                    <TableCell>النوع</TableCell>
                    <TableCell>الحالة</TableCell>
                    <TableCell>المطابخ المرتبطة</TableCell>
                    <TableCell>إجراء</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">لا يوجد مستخدمين للمطبخ.</TableCell>
                    </TableRow>
                  ) : (
                    users.map((user) => (
                      <TableRow key={user.id}>
                        <TableCell>{user.id}</TableCell>
                        <TableCell>{user.name}</TableCell>
                        <TableCell>{user.username}</TableCell>
                        <TableCell>{user.type}</TableCell>
                        <TableCell>{user.status === 1 ? "مفعل" : "غير مفعل"}</TableCell>
                        <TableCell>
                          {user.kitchens && user.kitchens.length > 0
                            ? user.kitchens.map((k) => k.name).join("، ")
                            : "لا يوجد"}
                        </TableCell>
                        <TableCell>
                          {user.kitchens && user.kitchens.length > 0 && (
                            <IconButton color="error" onClick={() => handleOpenUnlinkModal(user)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Paper>
          )}
        </Box>
      )}

      {tabIndex === 1 && (
        <Box>
          <Typography variant="h5" gutterBottom>
            تفعيل شاشة التجهيز
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenModal(true)}
            sx={{ mb: 2 }}
          >
            تفعيل شاشة التجهيز
          </Button>
        </Box>
      )}

      {/* مودال ربط الأجهزة بالمطبخ */}
      <Dialog open={openLinkModal} onClose={() => setOpenLinkModal(false)} maxWidth="xs" fullWidth>
        <DialogTitle>ربط جهاز بالمطبخ</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>اختر المستخدم</InputLabel>
            <Select
              value={selectedUserId}
              onChange={(e) => setSelectedUserId(e.target.value)}
              label="اختر المستخدم"
            >
              {users.map((user) => (
                <MenuItem key={user.id} value={user.id}>
                  {user.name} ({user.username})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>اختر المطبخ</InputLabel>
            <Select
              value={selectedKitchenId}
              onChange={(e) => setSelectedKitchenId(e.target.value)}
              label="اختر المطبخ"
            >
              {kitchens.map((kitchen) => (
                <MenuItem key={kitchen.id} value={kitchen.id}>
                  {kitchen.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {linkMsg && (
            <Alert severity={linkMsg.startsWith("✅") ? "success" : "error"} sx={{ mb: 2 }}>
              {linkMsg}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenLinkModal(false)}>إلغاء</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLinkUserToKitchen}
            disabled={linkLoading}
          >
            {linkLoading ? "جاري الحفظ..." : "حفظ الربط"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* مودال إزالة الربط */}
      <Dialog open={openUnlinkModal} onClose={() => setOpenUnlinkModal(false)} maxWidth="xs" fullWidth>
        <DialogTitle>إلغاء ربط المستخدم من المطبخ</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>اختر المطبخ</InputLabel>
            <Select
              value={unlinkKitchenId}
              onChange={(e) => setUnlinkKitchenId(e.target.value)}
              label="اختر المطبخ"
            >
              {unlinkKitchens.map((kitchen) => (
                <MenuItem key={kitchen.id} value={kitchen.id}>
                  {kitchen.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {unlinkMsg && (
            <Alert severity={unlinkMsg.startsWith("✅") ? "success" : "error"} sx={{ mb: 2 }}>
              {unlinkMsg}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenUnlinkModal(false)}>إلغاء</Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleRemoveUserFromKitchen}
            disabled={unlinkLoading}
          >
            {unlinkLoading ? "جاري الإلغاء..." : "تأكيد الإلغاء"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        fullScreen
      >
        <Box sx={{ position: "relative", height: "100%", bgcolor: "#232334", color: "#fff" }}>
          <IconButton
            onClick={() => setOpenModal(false)}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>
          <TaghezScreen />
        </Box>
      </Dialog>
    </Box>
  );
};

export default TaghezSetup;